import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,
    priceFormatter,
    customFormatter,
    linkFormatter,
    modifyStringFormatter,
    dateFormatter,customTableSelect,
    getFieldByPathFormatter,
    displayCustomDialog
} from 'util/Utils';
import Switch from "react-switch";
import FaTimesCircle from 'react-icons/lib/fa/times-circle';
import FaCartPlus from 'react-icons/lib/fa/cart-plus';

import formatNumbers  from 'util/formatNumbers';
import {UPDATE_PRODUCT}  from "actions/actionTypes";
import config from  '../../../config';

import moment   from 'moment'
import {Button} from 'react-bootstrap';

class SellerSubscriptionsListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            records: this.props.records,
            selectedRecordIDs:[],
        };
          this.selectRowProp = {
            mode: 'checkbox',
            columnWidth: '29px',
            onSelect: this.onRowSelect.bind(this),
            onSelectAll: this.onAllRowSelect.bind(this),
            customComponent: this.customMultiSelect.bind(this),
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({records: nextProps.records})
    }





    formatType(cell, row, extra){
        var foundType =  _.find(config.subscriptionTypes, function (value, key) {
            return key == row.Type
        })
        return foundType ? foundType.label  : ''
    }
    formatToggle(cell, row, extra){
         return <div className="toggleWrapper">
           <Switch onColor={'#ef5085'} onChange={()=>{
                 if (row.Type == 'Favorites' && row[extra.field] == 'Inactive'){
                   if (!_.get(row, ['Product', '_id'], false) || _.get(row, ['Product', 'Deleted'], false) ||   _.get(row, ['Product', 'Status']) == 'Inactive') {
                          this.setState({showProductIsNotAvailable:true})
                       return;
                   }
               }
           row['new'+extra.field] = row[extra.field] =='Active' ? 'Inactive' : 'Active'
           this.setState({})
           this.props.saveRecord(row,  {Status: row['new'+extra.field] })
       }} checked={_.get(row, 'new'+extra.field, row[extra.field]) == 'Active'} />
       </div>
    }

    formatAddToCart(cell, row, extra){
               if(_.includes(['Favorites', 'PriceDrop', 'InStock'],row.Type)) {
                  const {CustomData = {}, ProductTags = []} = row.Product ? row.Product : {};

                   if(row.Product) { /* if product exists in TUSH */
                      if (!row.Product.Deleted && row.Product.Status == 'Active' && _.get(row, 'Product.ProductVariants.0.Quantity', -1) > 0) {
                        if (ProductTags.find(tag=>tag.toLowerCase() == 'preorder') || CustomData.PreOrderCollection) {
                            return 'Available Soon';
                         }

                          return <FaCartPlus className="navyBlue font-size-25 cursor-pointer"
                                             onClick={(e) => {
                                                 this.props.addToCart(row)
                                             }}></FaCartPlus>
                      } else if (row.ShopifyProductID) {
                          return 'Sold Out'
                      }
                  }

        }
    }

    formatPrice(cell, row, extra){
        var  Price = ''
        if(_.includes(['InStock', 'Favorites', 'PriceDrop'],row.Type)) {
            if (_.get(row.Product, '_id')) {
                Price = formatNumbers.formatMoney(row.Product.ShopifyListingPrice)
            }
        }
       return  Price

    }

    formatDetails(cell, row, extra){
         var ProductName  = '',Price = '', textToMatch = '', Brand = '', Model = '', link = false
        if(row.Type== 'PriceDrop'){
            if (!_.isUndefined(row.DesirablePrice)) {
                Price = <div>{'Price limit: ' + formatNumbers.formatMoney(row.DesirablePrice)}</div>
            }
            ProductName = <div>{'Product: ' + _.get(row, ['Product', 'ProductName'], '')}</div>
             /* if subscription is related to specific Product */

            if (_.get(row, ['Product', '_id'])){
                if (  !row.Product.Deleted && row.Product.Status == 'Active' && _.get(row, 'Product.ProductVariants.0.Quantity', -1) > 0) {
                    if (_.get(row, ['Product', 'ShopifyProductHandle'])) {
                        var pageURL = config.getEnvironment().shopify.productCustomerUrlTemplate.replace("[product_handle]", _.get(row, ['Product', 'ShopifyProductHandle'],  ''))
                        ProductName = <a target="_blank" href={pageURL}>{ _.get(row, ['Product', 'ProductName'] )} </a>
                    }
                }else{
                    var pageURL  = config.getEnvironment().shopify.shopUrl + '/search?type=article%2Cpage%2Cproduct&q=' + encodeURIComponent(_.get(row, ['Product', 'ProductName'] ) )
                    ProductName = <a target="_blank" href={pageURL}>{ _.get(row, ['Product', 'ProductName'] )} </a>
                }
            }
                 return <div>{ProductName} {Price}  </div>

        } else   if(row.Type== 'InStock'){
            if (_.get(row, ['Product', 'ProductName'])) {
                ProductName =<div>{'Product: '+_.get(row, ['Product', 'ProductName'], '')}</div>
            }
            // if (_.get(row, ['GBGProduct', '_id'])) {
            //     Model = <div>{'Model: '+row.GBGProduct.Model}</div>
            //     Brand =  <div>{'Brand: '+row.GBGProduct.Model}</div>
            // }
            if (_.get(row, ['TextToMatch'])) {
                textToMatch =<div>{'Text: '+row.TextToMatch}</div>
            }
            /* if subscription is related to specific Product */

            if (_.get(row, ['Product', '_id'])){
                if (  !row.Product.Deleted && row.Product.Status == 'Active' && _.get(row, 'Product.ProductVariants.0.Quantity', -1) > 0) {
                    if (_.get(row, ['Product', 'ShopifyProductHandle'])) {
                        var pageURL = config.getEnvironment().shopify.productCustomerUrlTemplate.replace("[product_handle]", _.get(row, ['Product', 'ShopifyProductHandle'],  ''))
                        ProductName = <a target="_blank" href={pageURL}>{ _.get(row, ['Product', 'ProductName'] )} </a>
                    }
                }else{
                    var pageURL  = config.getEnvironment().shopify.shopUrl + '/search?type=article%2Cpage%2Cproduct&q=' + encodeURIComponent(_.get(row, ['Product', 'ProductName'] ) )
                    ProductName = <a target="_blank" href={pageURL}>{ _.get(row, ['Product', 'ProductName'] )} </a>
                }
            }
              return <div>{ProductName} {Model} {Brand} {textToMatch }</div>
        }else   if(row.Type== 'Favorites'){


            if ( _.get(row, ['Product', 'ShopifyProductHandle']) && _.get(row, ['Product', '_id'])   && !row.Product.Deleted &&   row.Product.Status == 'Active' && _.get(row,'Product.ProductVariants.0.Quantity',-1) > 0){ /* product exists in TUSH */
                    link = config.getEnvironment().shopify.productCustomerUrlTemplate.replace("[product_handle]", _.get(row, ['Product', 'ShopifyProductHandle'],_.get(row, ['SubscriptionCustomData', 'ShopifyProductHandle'])))
            } else   if (  _.get(row, ['SubscriptionCustomData', 'ProductExistsOnlyInShopify']) &&  _.get(row, ['SubscriptionCustomData', 'ShopifyProductHandle'])) { /* product does not exist in TUSH */
                  link = config.getEnvironment().shopify.productCustomerUrlTemplate.replace("[product_handle]", _.get(row, ['SubscriptionCustomData', 'ShopifyProductHandle']))
               return  <a target="_blank" href={link}>{ _.get(row, ['Product', 'ShopifyProductHandle'],_.get(row, ['SubscriptionCustomData', 'ShopifyProductName']))} </a>
            } else  if (_.get(row, ['SubscriptionCustomData', 'ShopifyProductName'] )) {
                 link = config.getEnvironment().shopify.shopUrl + '/search?type=article%2Cpage%2Cproduct&q=' + encodeURIComponent(_.get(row, ['SubscriptionCustomData', 'ShopifyProductName']) )
           }
           if (link) {
               return <a target="_blank" href={link}>{ _.get(row, ['SubscriptionCustomData', 'ShopifyProductName'],_.get(row, ['SubscriptionCustomData', 'ShopifyProductName'] ))} </a>
           }
        }

    }
    onRowSelect(row, isSelected, e) {

          if (isSelected) {
            this.setState({selectedRecordIDs: this.state.selectedRecordIDs.concat([row._id])}, function () {
                this.props.onSelectHandler()
            })
        } else {
            this.setState({selectedRecordIDs: _.pull([...this.state.selectedRecordIDs], row._id)}, function () {
                this.props.onSelectHandler()
            })
        }
    }

    onAllRowSelect(isSelected, rows) {
        if (isSelected) {
            this.setState({
                selectedRecordIDs: _.uniq(this.state.selectedRecordIDs.concat(_.map(rows, '_id')))
            }, function () {
                this.props.onSelectHandler()
            })
        } else {
            if (rows.length) {
                this.setState({selectedRecordIDs: _.pullAll(this.state.selectedRecordIDs, _.map(rows, '_id'))},function() {
                    this.props.onSelectHandler()
                })
            } else { /* this is some bug occurred when clicking on header checkbox in indeterminate state  */
                this.setState({selectedRecordIDs: []}, function () {
                    this.props.onSelectHandler()
                })
            }
        }
    }

    customMultiSelect(props) {
        return customTableSelect(props, {table:this.refs.table, selectedRows:this.state.selectedRecordIDs});
    }


    render() {
         var self = this;

         return (
            <div className="databases-table subscriptions-table">
                <BootstrapTable data={this.state.records} ref='table'
                                remote={ true }
                                hover={true}
                                striped={true}
                                selectRow={ this.props.displayShareMyWishList ? this.selectRowProp : undefined }
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange,
                                 } }
                >
                    <TableHeaderColumn width="40px"dataFormat={this.formatToggle.bind(this)}
                                       formatExtraData={ {'field': 'Status' } } columnClassName={'toggleCell'}
                                       dataField='Status' dataAlign="center" dataSort={true}>Active</TableHeaderColumn>

                    <TableHeaderColumn   width="80px" dataFormat={this.formatType.bind(this)}  dataField='Type' dataAlign="center" dataSort={true}>Type</TableHeaderColumn>
                    <TableHeaderColumn  dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                        hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn width="120px"
                                       dataFormat={this.formatPrice.bind(this)} dataAlign="center" dataSort={false}>Price</TableHeaderColumn>
                     <TableHeaderColumn width="120px"
                                       dataFormat={this.formatDetails.bind(this)} dataAlign="center" dataSort={false}>Details</TableHeaderColumn>

                    <TableHeaderColumn width="120px"
                                       dataFormat={this.formatAddToCart.bind(this)} dataAlign="center" dataSort={false}>Add To Cart</TableHeaderColumn>

                    <TableHeaderColumn width="40px" dataSort={false}
                                       dataFormat={  function(cell, row, extra){

                                               return  <FaTimesCircle className="deleteButton"
                                                              onClick={(e) =>{
                                                                  self.props.saveRecord(row,  {Deleted: true })

                                                              }}></FaTimesCircle>
                                           }}
                                       dataAlign="center" >Remove</TableHeaderColumn>
                 </BootstrapTable>
                {displayCustomDialog.call(this, {
                    cancelButtonTitle:'Close',
                    buttonTitle:'doNotDisplay',
                    cancelActionHandler:()=>{
                    },
                    confirmActionHandler: (data) => {
                    },
                    modalTitle:'This product is no longer available. You can click on the product link to search for similar products',
                     dialogID: 'ProductIsNotAvailable'
                })}
            </div>
        );
    }
}


export default SellerSubscriptionsListTable;
